import { Injectable } from '@angular/core';
import { finalize, Observable, Subject } from 'rxjs';
import { ProfileType } from 'services/shared/model/graph.model';
import { GraphService } from './graph.service';
import { UserService } from '#services/api';
import { User } from 'models';
import { Role } from 'enums';
import { CalAngularService, ICvxClaimsPrincipal } from '@cvx/cal-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public profile = new Subject<ProfileType | null>();
  public loginDisplay = new Subject<boolean | null>();
  public cvxClaimsPrincipal: ICvxClaimsPrincipal | null = null;
  private currentUser: User;

  constructor(
    private calService: CalAngularService,
    private graphService: GraphService,
    private userSvc: UserService
  ) {
    this.initializeAuth();
  }

  private initializeAuth(): void {
    this.calService.isUserSignedIn().subscribe({
      next: (isSignedIn) => {
        if (isSignedIn) {
          this.cvxClaimsPrincipal = this.calService.cvxClaimsPrincipal;
          this.getUserProfile();
          this.setLoginDisplay();
        }
      },
      error: (error) => {
        console.error('CAL initialization failed:', error);
      }
    });
  }

  getUserProfile(): void {
    this.graphService.getAdUserProfile().subscribe(userProfile => this.profile.next(userProfile));
  }

  getUserProfileDetails(): Observable<ProfileType> {
    return this.graphService.getAdUserProfile();
  }

  setLoginDisplay(): void {
    this.calService.isUserSignedIn().subscribe(isSignedIn => {
      this.loginDisplay.next(isSignedIn);
    });
  }

  logout(): void {
    this.calService.userInitiatedSignOut().subscribe({
      next: () => {
        this.profile.next(null);
        this.loginDisplay.next(null);
        this.cvxClaimsPrincipal = null;
      },
      error: (error) => {
        console.error('Logout failed:', error);
      }
    });
  }
 
  // acceptDisclaimer(): void {
  //   this.userSvc.acceptDisclaimer()
  //     .pipe(finalize(() => window.location.reload()))
  //     .subscribe();
  // }
 
acceptDisclaimer(): void {
  this.userSvc.acceptDisclaimer()
    .pipe(finalize(() => {
     
      console.log('Disclaimer accepted');
    }))
    .subscribe();
}
 
 
 
  getCurrentUser(): User {
    return this.currentUser;
  }
 
  hasRole(role: Role): boolean {
    let roleId = localStorage.getItem('currentUserRole');
    if (roleId == null) {
      this.loadUserInfo();
      roleId = localStorage.getItem('currentUserRole');
    }
    return !!roleId && Number(roleId) === role;
  }
 
  loadUserInfo(): Promise<User> {
    return this.userSvc.getCurrentUser()
      .toPromise()
      .then((userInfo: User) => {
        this.currentUser = userInfo;
        localStorage.setItem('currentUserRole', this.currentUser.RoleID.toString());
        return userInfo;
      });
  }
}